import React from 'react';

import NumericalSummary from 'components/NumericalSummary';

const NumericalComponent = props =>
  <NumericalSummary {...props} hideParametersTypeLabel />;

export default NumericalComponent;
